import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import defaultsDeep from 'lodash/defaultsDeep';
import classnames from 'classnames';

import modalService from '../../../../components/modal/modalService';
import DropdownMultiSelect from '../../../../components/DropdownMultiSelect';
import Dropdown from '../../../../components/Dropdown';


const renderSelectedAccounts = (field, available, selected) => {
  let label;
  if(selected && selected.length){
    const allSelected = selected.indexOf(DEFAULT_SELECT_ALL_ID) > -1;
    label = [`${field}s `, (<span key={`selected-${field}`} className="badge badge-primary">{allSelected ? available.length - 1 : selected.length}</span>)];
  }else{
    label = `Select a ${field}`;
  }
  return (
    <span>{label}</span>
  );
};

const renderItem = (items, e) => {
  const allSelected = items.indexOf(DEFAULT_SELECT_ALL_ID) > -1;
  const isDisabled = allSelected && e.id !== DEFAULT_SELECT_ALL_ID;
  const classes = { "multiselect-item": true, disabled: isDisabled }
  return (
    <div key={e.id} className={classnames(classes)}>
      <input
        key={`sel-${e.id}`}
        type="checkbox"
        disabled={isDisabled}
        checked={allSelected || items.indexOf(e.id) > -1} /> {e.name}
    </div>
  );
};

const DEFAULT_SELECT_ALL_ID = -1;
const addAllSelected = (input) => {
  input = [...input];
  if(input.length === 0){
    input.push(DEFAULT_SELECT_ALL_ID);
  }
  return input;
};

const removeAllSelected = (input) => {
  return input.filter(id => id !== DEFAULT_SELECT_ALL_ID);
};

const  getVerticalTemplate = (scoreSetDefaults, verticalId) => {
  let verticalScoreSetTemplate = scoreSetDefaults.filter(ssd => ssd.verticalIds.indexOf(verticalId) > -1)[0];
  if (verticalScoreSetTemplate) {
    return verticalScoreSetTemplate;
  }
  return scoreSetDefaults.filter(ssd => !ssd.verticalIds.length)[0];
};
//TODO - remove from view logic
const newProvidersFromTemplate = (scoreSet, prevScoreSet, template) => {
  if(prevScoreSet.verticalIds[0] !== scoreSet.verticalIds[0]) {
    const findAndAssignProviders = (scoreConfigComponents, templateConfigComponents) => {
      for (let i = 0; i < templateConfigComponents.length; i++) {
        let currScore = scoreConfigComponents[i];
        let currTemplate = templateConfigComponents[i];

        if (currTemplate.id.indexOf('providers') !== -1) {
          scoreConfigComponents[i] = cloneDeep(currTemplate);
        } else if (currTemplate.components.length) {
          findAndAssignProviders(currScore.components, currTemplate.components);
        }
      }
    };
    findAndAssignProviders(scoreSet.scoreConfig.components, template.scoreConfig.components);
  }
  return scoreSet
}

const sameIds = (currentConfig, previousConfig) => {
  if(currentConfig._id && previousConfig._id && !previousConfig.isDefault){
    return currentConfig._id.oid === previousConfig._id.oid
  }
  return false
}

class CreateEditScoreSet extends Component{
  constructor(props){
    super(props);
    this.state = {
      accounts: [],
      verticals: [],
      scoreSet: null,
      nameChanged: false
    };

    this.onSaveClick = this.onSaveClick.bind(this);
  }

  componentWillMount() {
    //TODO - move this stuff out of the view
    //clean state for fresh edits
    const {accounts, scoreSet, scoreSets, scoreSetDefaults, scoreConfigTemplate, verticals, type} = this.props;
    //add ability to select all and normalize the data
    const verticalAccountsHash = {};
    scoreSets.forEach(ss => {
      ss.verticalIds.map(ssVID => {
        verticalAccountsHash[ssVID] = verticalAccountsHash[ssVID] ? [...verticalAccountsHash[ssVID], ...ss.accountIds] : [...ss.accountIds];
      });
    });

    const displayVerticals = [
      { id: -1 , name: 'All ' },
                              //only display verticals for locations the user has
      ...cloneDeep(verticals).filter(vertical => verticalAccountsHash[vertical._id]).map(vertical => { return { id: vertical._id, name: vertical.name }; })
    ];
    const displayAccounts = [
      { id: -1, name: 'All Accounts' },
      ...cloneDeep(accounts).map(account => { return { id: account.id, name: account.accountName }; })
    ];


    let newScoreSet;
    let newConfig;
    switch(type){
      case CreateEditScoreSet.Types.EDIT:
        newScoreSet = {
          ...cloneDeep(scoreSet),
          accountIds: addAllSelected(scoreSet.accountIds),
          verticalIds: addAllSelected(scoreSet.verticalIds)
        };

        break;
      case CreateEditScoreSet.Types.CLONE:
        newConfig = {
          ...cloneDeep(scoreConfigTemplate.scoreConfig),
          ...{
            name: `${scoreConfigTemplate.scoreConfig.name} Clone`,
            _id: undefined,
            billingAccountId: undefined,
            lastUpdatedBy: undefined
          }
        };
        newScoreSet = {
          scoreConfig: newConfig,
          verticalIds: [...scoreConfigTemplate.verticalIds],
          accountIds: []
        };
        break;
      case CreateEditScoreSet.Types.CREATE:
        newScoreSet = {
          scoreConfig: {
            name: ''
          },
          verticalIds: [],
          accountIds: []
        };
      break;
    }

    this.setState({
      accounts: displayAccounts,
      verticals: displayVerticals,
      verticalAccountsHash,
      scoreSet: newScoreSet
    });
  }

  onLabelChange(e){
    //TODO - might get too deep
    const scoreSet = cloneDeep(this.state.scoreSet);
    scoreSet.scoreConfig.name = e.target.value;
    this.setState({ scoreSet, error: undefined });
  }

  onSelect(property, e) {
    const scoreSet = {...this.state.scoreSet};
    let selProperty = [...scoreSet[property]];
    const i = selProperty.indexOf(e.id);

    if(i === -1){
      if(e.id === DEFAULT_SELECT_ALL_ID){
        selProperty = [DEFAULT_SELECT_ALL_ID];
      }else if(selProperty.indexOf(DEFAULT_SELECT_ALL_ID) === -1){
        selProperty.push(e.id);
      }
    }else{
      selProperty.splice(i, 1);
    }
    scoreSet[property] = selProperty;

    this.setState({ scoreSet, error: undefined });
  }
  getVerticalCount(id){
    return this.props.scoreSets.filter(ss => !ss.scoreConfig.isDefault).reduce((total, scoreSet) => {
      if(scoreSet.verticalIds.indexOf(id) >= 0) total++;
      return total
    }, 1)
  }
  onVerticalSelect(e){
    let name = e.name;
    const scoreSet = {...this.state.scoreSet};
    scoreSet.verticalIds = [e.id];
    scoreSet.accountIds = [];
    scoreSet.scoreConfig = { ...scoreSet.scoreConfig, name};
    this.setState({ scoreSet, error: undefined });
  }

  onSaveClick(e) {
    const {onCreate, onSave, type, scoreSetsDefaults, scoreSets} = this.props;
    let prevScoreSet = this.props.scoreSet;
    let {scoreSet} = this.state;
    //validations
    if (!scoreSet.scoreConfig.name) {
      this.setState({error: 'Enter a score template name'});
      return;

    }else if(scoreSets.filter(set =>
        !set.scoreConfig.isDefault
            //sorry for this
        && (!this.props.scoreSet || !sameIds(this.props.scoreSet.scoreConfig, set.scoreConfig))
        && set.scoreConfig.name.trim() === scoreSet.scoreConfig.name.trim()).length
    ){
      this.setState({error: 'Enter a unique score template name'});
      return;
    }else if(!scoreSet.verticalIds.length){
      this.setState({error: 'Select an Industry'});
      return;
    }else if(!scoreSet.accountIds.length){
      this.setState({error: 'Select one or more accounts'});
      return;
    }

    //empty arrays define selected all

    scoreSet.accountIds = removeAllSelected(scoreSet.accountIds);
    scoreSet.verticalIds = removeAllSelected(scoreSet.verticalIds);

    let template;
    switch(type){
      case CreateEditScoreSet.Types.CREATE:
        template = getVerticalTemplate(scoreSetsDefaults, scoreSet.verticalIds[0])
        break;
      case CreateEditScoreSet.Types.EDIT:
      case CreateEditScoreSet.Types.CLONE:
      default:
        template = getVerticalTemplate(scoreSets.filter(ss => ss.scoreConfig.isDefault), scoreSet.verticalIds[0]);
      break;
    }


    switch(type){
      case CreateEditScoreSet.Types.EDIT:
        newProvidersFromTemplate(scoreSet, prevScoreSet, template);
        onSave(scoreSet);
        break;
      case CreateEditScoreSet.Types.CREATE:
        let newScoreSet;
        newScoreSet = defaultsDeep(
          scoreSet,
          {scoreConfig: defaultsDeep(scoreSet.scoreConfig,  template.scoreConfig)});
        onCreate(newScoreSet);
        break;
      case CreateEditScoreSet.Types.CLONE:
      default:
        newProvidersFromTemplate(scoreSet, prevScoreSet, template);
        onCreate(scoreSet);
        break;
    }
  }

  render(){
    const {scoreSet, verticals, verticalAccountsHash, error} = this.state;
    let heading;
    let btnLabel;

    switch(this.props.type){
      case CreateEditScoreSet.Types.CLONE:
        heading = 'Clone Score Settings';
        btnLabel = 'Clone Set';
        break;
      case CreateEditScoreSet.Types.EDIT:
        heading = 'Edit Score Settings';
        btnLabel = 'Save Set';
        break;
      case CreateEditScoreSet.Types.CREATE:
      default:
        heading = 'Create Score Settings';
        btnLabel = 'Create Set';
        break;
    }
    const accounts = this.state.accounts
                        .filter(account => {
                          //Checks to see if the it currently associated with score set so it does not get filtered
                          if(account.id === -1 || !!(this.props.scoreSet && this.props.scoreSet.accountIds.indexOf(account.id) !== -1)) return true;
                          // right now only one selected vertical so just look at the first,
                          // filter list of accounts if they exist in that vertical
                          if(scoreSet.verticalIds.length && verticalAccountsHash[scoreSet.verticalIds[0]]){
                            return verticalAccountsHash[scoreSet.verticalIds[0]].indexOf(account.id) === -1 || scoreSet.accountIds.indexOf(account.id) >= 0;
                          }
                          return true;
                        });

    const accountIds = scoreSet.accountIds;
    const verticalIds = scoreSet.verticalIds;

    let selectedVertical;
    if(verticalIds.length){
      let filtered = verticals.filter(v => v.id === verticalIds[0]);
      if(filtered.length) selectedVertical = filtered[0];
    }

    return (
      <React.Fragment>
        <div className="modal-header d-flex align-items-center justify-content-between">
          <h4 className="modal-title">{heading}</h4>
          <button className="pull-right btn btn-link p-0" onClick={modalService.closeModal}><i className="far fa-times" /></button>
        </div>
        <div className="modal-body">
          <Dropdown
            className="form-group"
            btnClass="btn-block"
            items={verticals}
            selected={selectedVertical}
            renderItem={e => e ? e.name : 'Select an Industry'}
            getKey={e => e ? e.id : 'None'}
            onSelected={this.onVerticalSelect.bind(this)}
          />
          <DropdownMultiSelect
            className="form-group"
            btnClass="btn-block"
            disabled={!verticalIds.length}
            items={accounts}
            selected={accountIds}
            renderItem={renderItem.bind(this, accountIds)}
            renderSelected={renderSelectedAccounts.bind(this, "Account", this.state.accounts)}
            getKey={e => e.id}
            onSelected={this.onSelect.bind(this, "accountIds")}
          />
          <input
            ref={(nameTxt => this.nameTxt = nameTxt)}
            type="text"
            className="form-control"
            value={scoreSet ? scoreSet.scoreConfig.name : ""}
            onChange={this.onLabelChange.bind(this)}
          />
        </div>
        <div className="modal-footer">
          <div className="text-danger text-right w-100">
            {!!error && error}
          </div>
          <div className="d-flex justify-content-end">
            <button className="btn btn-outline-secondary" onClick={modalService.closeModal}>Cancel</button>
            <button className="btn btn-secondary control-spacer-left" onClick={this.onSaveClick}>{btnLabel}</button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
CreateEditScoreSet.propTypes = {
  accounts: PropTypes.array.isRequired,
  verticals: PropTypes.array.isRequired,
  scoreSet: PropTypes.object,
  scoreSets: PropTypes.array,
  scoreConfigTemplate: PropTypes.object,
  onCreate: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  type: PropTypes.string
};

CreateEditScoreSet.Types = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  CLONE: 'CLONE',

};
export default CreateEditScoreSet;
